"use strict";
(function () {
  if (!customElements.get("tabs-product-gallery")) {
    class TabsProductGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          slider: null,
        };
        this.swiper = null;
      }

      connectedCallback() {
        this.setupElements();
        this.initSwiper();
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      setupElements() {
        this.elements.slider = this.querySelector('[data-component="swiper"]');
      }

      initSwiper() {
        if (!this.elements.slider) return;

        this.swiper = new Swiper(this.elements.slider, {
          effect: "fade",
          fadeEffect: { crossFade: true },
          loop: false,
          speed: 500,
          autoHeight: true,
          slidesPerView: 1,
          watchSlidesProgress: true,
        });
      }

      /**
       * Activate a slide by data-image-id value
       * @param {string|number} imageId - The ID from data-image-id attribute
       */
      setActiveSlideById(imageId) {
        if (!this.swiper || !imageId) return;

        const slides = this.elements.slider.querySelectorAll(".swiper-slide");
        const targetIndex = Array.from(slides).findIndex(
          (slide) => slide.dataset.imageId === String(imageId),
        );

        if (targetIndex !== -1) {
          this.swiper.slideTo(targetIndex);
        }
      }
    }

    customElements.define("tabs-product-gallery", TabsProductGallery);
  }

  if (!customElements.get("tabs-product-select")) {
    class TabsProductSelect extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          select: null,
          product: null,
          gallery: null,
          form: null,
        };
        this.onVariantChange = this.onVariantChange.bind(this);
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }
    }

    TabsProductSelect.prototype.setupElements = function () {
      this.elements.select = this.querySelector('[data-component="select"]');
      this.elements.product = this.closest(".tabs-product");
      this.elements.form =
        this.elements?.product?.querySelector(".product-form");
      this.elements.gallery =
        this.elements?.product?.querySelector('[data-component="gallery"]') ||
        null;
    };

    TabsProductSelect.prototype.addEventListeners = function () {
      if (this.elements.select) {
        this.elements.select.addEventListener("change", this.onVariantChange);
      }
    };

    TabsProductSelect.prototype.removeEventListeners = function () {
      if (this.elements.select) {
        this.elements.select.removeEventListener(
          "change",
          this.onVariantChange,
        );
      }
    };

    TabsProductSelect.prototype.onVariantChange = function (e) {
      this.updateId(e);
      this.updateImage(e);
      const event = new CustomEvent("tabs-product:update", {
        bubbles: true,
      });

      this.dispatchEvent(event);
    };

    TabsProductSelect.prototype.updateImage = function (e) {
      const selectedOption = event.target.selectedOptions[0];
      const imageId = selectedOption?.dataset.imageId;

      if (imageId && this.elements.gallery) {
        this.elements.gallery.setActiveSlideById(imageId);
      }
    };

    TabsProductSelect.prototype.setCurrentElement = function (e) {};

    TabsProductSelect.prototype.updateId = function (e) {
      const selectedOption = e.target.selectedOptions[0];
      const variantId = selectedOption?.dataset.variantId;
      const { form } = this.elements;

      if (!variantId || !form) return;

      const variantInput = form.querySelector(".product-variant-id");

      if (!variantInput) return;

      variantInput.value = variantId;
    };

    TabsProductSelect.prototype.onFetch = function (e) {
      const selectedOption = e.target.selectedOptions[0];
      const variantId = selectedOption?.dataset.variantId;

      if (!variantId) return;
    };

    customElements.define("tabs-product-select", TabsProductSelect);
  }

  if (!customElements.get("tabs-product")) {
    class TabsProduct extends HTMLElement {
      constructor() {
        super();
        this.pickupAvailabilitySelector = ".ot-estimated-shipping";
        this.elements = {
          priceContainer: null,
          select: null,
          quantity: null,
          submitBtn: null,
          shipping: null,
          mainProduct: null,
          mainProductQuantity: null,
          mainProductVariant: null,
        };
        this.mainProductURL = null;
        this.mainProductSectionId = null;
        this.currentVariant = null;
        this.onProductUpdate = this.onProductUpdate.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.isSyncingFromTabs = false;
        this.isSyncingFromMain = false;
        this.isSyncingVariantFromMain = false;
        this.isSyncingVariantFromTabs = false;
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
        this.onInit();
      }

      disconnectedCallback() {}
    }

    TabsProduct.prototype.setupElements = function () {
      this.elements.mainProduct = document.querySelector("product-info");
      this.elements.mainProductQuantity = document.querySelector(
        ".product__info-wrapper .custom-quantity__input",
      );
      this.elements.mainProductVariant = document.querySelector(
        ".product__info-wrapper .product-variant-id",
      );
      this.elements.quantity = this.querySelector(".quantity__input");
      this.elements.priceContainer = this.querySelector(".tabs-product-price");
      this.elements.select = this.querySelector("[data-component='select']");
      this.elements.quantity = this.querySelector(".quantity__input");
      this.elements.submitBtn = this.querySelector(".product-form__submit");
      this.elements.shipping = this.querySelector(
        "[data-component='shipping']",
      );
    };

    TabsProduct.prototype.addEventListeners = function () {
      const { quantity, mainProductQuantity, mainProductVariant, select } =
        this.elements;
      if (quantity) {
        quantity.addEventListener("change", this.onInputChange);
      }

      if (mainProductQuantity) {
        mainProductQuantity.addEventListener(
          "change",
          this.onMainQuantityChange.bind(this),
        );
        mainProductQuantity.addEventListener(
          "input",
          this.onMainQuantityChange.bind(this),
        );
      }

      if (mainProductVariant) {
        mainProductVariant.addEventListener(
          "change",
          this.onMainVariantChange.bind(this),
        );
      }

      if (select) {
        select.addEventListener("change", this.onTabsVariantChange.bind(this));
      }

      this.addEventListener("tabs-product:update", this.onProductUpdate);
    };

    TabsProduct.prototype.onInit = function () {
      setTimeout(() => {
        const mainProductContainer = document.querySelector(
          ".product__info-container",
        );

        const activeTier = mainProductContainer?.querySelector(
          ".product__info-container .price-tier--active",
        );

        this.updatePrice(activeTier);
        this.updatePickupAvailability(mainProductContainer);
      }, 500);
    };

    TabsProduct.prototype.onProductUpdate = async function () {
      try {
        const res = await fetch(
          `${this.getSectionURL()}?section_id=${this.getSectionId()}`,
        );

        if (!res.ok) return;

        const textHTML = await res.text();

        // Parse textHTML into DOM
        const parser = new DOMParser();
        const html = parser.parseFromString(textHTML, "text/html");

        const cartQuantity = await this.getCartItemQuantity();

        this.updateTier(html, cartQuantity);
        this.updateButton(html);
      } catch (e) {
        console.error("TabsProduct update error:", e);
      }
    };

    TabsProduct.prototype.updateTier = function (html, cartQuantity) {
      const { quantity } = this.elements;

      const currentQuantity = quantity.value;

      const totalQuantity = +currentQuantity + +cartQuantity;

      const tiers = html.querySelectorAll(".price-tier");
      if (!tiers) {
        this.updatePrice();
        return;
      }

      const tiersAmounts = this.getTiersAmounts([...tiers]);

      let matchIndex = 0;

      for (let i = 0; i < tiersAmounts.length; i++) {
        const start = tiersAmounts[i];
        const end = tiersAmounts[i + 1] ? tiersAmounts[i + 1] - 1 : Infinity;

        if (totalQuantity >= start && totalQuantity <= end) {
          matchIndex = i;
          break;
        }
      }

      const activeTier = tiers[matchIndex];
      this.updatePrice(activeTier);
    };

    TabsProduct.prototype.updatePrice = function (tier) {
      const { priceContainer } = this.elements;
      if (!priceContainer) return;
      if (!tier) {
        priceContainer.classList.add("hidden");
        return;
      }

      priceContainer.classList.remove("hidden");

      priceContainer.querySelector(".tabs-product-price__text").innerHTML =
        tier.querySelector(".quantity-text")?.innerHTML;

      priceContainer.querySelector(
        ".tabs-product-price__gross-price",
      ).innerHTML = tier.querySelector(".gross-price")?.innerHTML;

      priceContainer.querySelector(".tabs-product-price__amount").innerHTML =
        tier.querySelector(".price-amount")?.innerHTML;

      priceContainer.querySelector(
        ".tabs-product-price__base-price",
      ).innerHTML = tier.querySelector(".base-price")?.innerHTML;
    };

    TabsProduct.prototype.updatePickupAvailability = function (html) {
      const { shipping } = this.elements;
      if (!shipping) return;
      if (!html) {
        shipping.classList.add("hidden");
        return;
      }

      const newPickupAvailability = html.querySelector(
        this.pickupAvailabilitySelector,
      );
      if (!newPickupAvailability) return;

      shipping.innerHTML = newPickupAvailability.innerHTML;
      shipping.classList.remove("hidden");
    };

    TabsProduct.prototype.updateButton = function (html) {
      const { submitBtn } = this.elements;
      const atc = html.querySelector(".product-form__submit");
      if (!atc || !submitBtn) return;

      submitBtn.innerHTML = atc.innerHTML;

      if (atc.hasAttribute("disabled")) {
        submitBtn.setAttribute("disabled", "disabled");
      } else {
        submitBtn.removeAttribute("disabled");
      }
    };

    TabsProduct.prototype.getSectionURL = function () {
      let url = this.mainProductURL;
      if (!url) {
        url = document.querySelector("product-info")?.dataset?.url;
        this.mainProductURL = url;
      }
      return url;
    };

    TabsProduct.prototype.getSectionId = function () {
      let id = this.mainProductSectionId;
      if (!id) {
        id = document.querySelector("product-info")?.dataset?.section;
        this.mainProductSectionId = id;
      }
      return id;
    };

    TabsProduct.prototype.getCartItemQuantity = async function () {
      try {
        const response = await fetch("/cart.js");
        const cart = await response.json();

        const productId = this.dataset.productId;
        if (!productId) return;

        let newTotalProductQty = 0;
        const newVariantQuantities = {};

        // Collect quantities for this product + its variants
        cart.items.forEach((item) => {
          if (item.product_id.toString() === productId) {
            newTotalProductQty += item.quantity;
            newVariantQuantities[item.variant_id] =
              (newVariantQuantities[item.variant_id] || 0) + item.quantity;
          }
        });

        return newTotalProductQty || 0;
      } catch (error) {
        console.error("❌ Error fetching or processing cart data:", error);
      }
    };

    TabsProduct.prototype.getTiersAmounts = function (tiers) {
      if (!tiers) {
        return [];
      }
      return tiers.map((t) => +t?.dataset?.fromAmount);
    };

    TabsProduct.prototype.onInputChange = function (e) {
      const { mainProductQuantity } = this.elements;

      if (!mainProductQuantity) return;

      // Prevent loop if update came from main → tabs
      if (!this.isSyncingFromMain) {
        this.isSyncingFromTabs = true;
        mainProductQuantity.value = e.target.value;

        // Trigger all main input events
        mainProductQuantity.dispatchEvent(
          new Event("input", { bubbles: true }),
        );
        mainProductQuantity.dispatchEvent(
          new Event("change", { bubbles: true }),
        );
        this.isSyncingFromTabs = false;
      }

      const event = new CustomEvent("tabs-product:update", {
        bubbles: true,
      });

      this.dispatchEvent(event);
    };

    TabsProduct.prototype.onMainQuantityChange = function (e) {
      const { quantity } = this.elements;
      if (!quantity) return;

      if (!this.isSyncingFromTabs) {
        this.isSyncingFromMain = true;
        quantity.value = e.target.value;

        // Trigger internal update
        quantity.dispatchEvent(new Event("input", { bubbles: true }));
        quantity.dispatchEvent(new Event("change", { bubbles: true }));
        this.isSyncingFromMain = false;
      }
    };

    TabsProduct.prototype.onMainVariantChange = function (e) {
      const { select } = this.elements;
      if (!select) return;

      const variantId = e.target.value;
      if (!variantId) return;

      if (this.isSyncingVariantFromTabs) return;

      this.isSyncingVariantFromMain = true;
      select.value = variantId;
      select.dispatchEvent(new Event("change", { bubbles: true }));
      this.isSyncingVariantFromMain = false;
    };

    TabsProduct.prototype.onTabsVariantChange = async function (e) {
      const { quantity, mainProduct, mainProductVariant } = this.elements;
      if (!mainProductVariant) return;

      const variantId = e.target.value;
      if (!variantId) return;

      if (this.isSyncingVariantFromMain) return;

      this.isSyncingVariantFromTabs = true;

      // Sync to main product
      mainProductVariant.value = variantId;
      mainProductVariant.dispatchEvent(new Event("change", { bubbles: true }));

      // Update URL
      this.updateURLVariant(variantId);

      if (mainProduct) {
        await mainProduct.updateByVariantId(variantId);
      }

      // Synchronize quantity
      quantity.dispatchEvent(new Event("change", { bubbles: true }));

      this.isSyncingVariantFromTabs = false;
    };

    TabsProduct.prototype.updateURLVariant = function (variantId) {
      if (!variantId) return;

      const url = new URL(window.location.href);
      url.searchParams.set("variant", variantId);

      history.replaceState({}, "", url);
    };

    customElements.define("tabs-product", TabsProduct);
  }
})();
